
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/arctic/griptumbler",
      function () {
        return require("private-next-pages/brands/arctic/griptumbler.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/arctic/griptumbler"])
      });
    }
  